import { isBusinessCustomer } from '../customer/customerDetails';
import { isCustomerPendingActivation } from '../customer/customerStatus';
export const getLDCustomerProperties = (customer) => {
    var _a;
    if (!customer) {
        return {};
    }
    return {
        customerId: customer === null || customer === void 0 ? void 0 : customer.id,
        investorCountry: ((_a = customer === null || customer === void 0 ? void 0 : customer.address) === null || _a === void 0 ? void 0 : _a.countryCode) || '',
        investorType: isBusinessCustomer(customer) ? 'business' : 'retail',
        investorStatus: isCustomerPendingActivation(customer) ? 'non-exported' : 'exported',
        distributor: customer.distributorId,
    };
};
//# sourceMappingURL=buildCustomerProperties.js.map